import React from 'react';
import { trackPixelEvent } from './MetaPixel';
interface CTAButtonProps {
  label: string;
  href?: string;
  className?: string;
  /** Overrides only the label sizing, so long labels can stay on a single line. */
  textClassName?: string;
}
export function CTAButton({
  label,
  href = '#comprar',
  className = '',
  textClassName = 'text-base sm:text-[17px]'
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith('http');
  return <a href={href} onClick={() => {
    if (goesToCheckout) trackPixelEvent('InitiateCheckout');
  }} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[10px] bg-aura px-4 py-4 text-center font-extrabold text-white shadow-lg shadow-plum/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-aura sm:px-6 ${textClassName} ${className}`} data-id="element-82" data-mp="2tx9tsi7tvc0v">
      {label}
    </a>;
}